import React, { Component } from 'react';
import './AboutUs.scss';
import Header from '../../components/Header/header';
import Footer from '../../components/Footer/Footer';
import { aboutUsPage } from '../../global/texts/AboutUs';
import MissionImg1 from '../../Assets/images/AboutUs/missionImg1.jpg';
import MissionImg2 from '../../Assets/images/AboutUs/missionImg2.jpg';
import BusinessImg from '../../Assets/images/AboutUs/BusinessImg.png';
import SunImg from '../../Assets/images/AboutUs/SunImg.png';
import Bloomberg from '../../Assets/images/AboutUs/Bloomberg.png';
import BusinessMob from '../../Assets/images/AboutUs/BusinessMob.png';
import SunMob from '../../Assets/images/AboutUs/SunMob.png';
import BloombergMob from '../../Assets/images/AboutUs/BloombergMob.png';
import CEOImg from '../../Assets/images/AboutUs/CEOImg.png';
import MeetOfficeMen from '../../Assets/images/AboutUs/meetMens.jpg';
import MeetOfficeMenIpadPro from '../../Assets/images/AboutUs/meetinMenIpadPro.jpg';
import MeetMen from '../../Assets/images/AboutUs/meetMen.jpg';
import MeetOffice from '../../Assets/images/AboutUs/meetOffice.jpg';
import MeetWomen from '../../Assets/images/AboutUs/meetsWomens.jpg';
import MeetMenIpadPro from '../../Assets/images/AboutUs/menIpadpro.jpg';
import MeetImg from '../../Assets/images/AboutUs/MeetImgs.jpg';
import MeetImgIpadPro from '../../Assets/images/AboutUs/meetWomenIpadpro.jpg';
import MeetofficeTab from '../../Assets/images/AboutUs/meetofficeTab.jpg';
import MeetWomenIpadPro from '../../Assets/images/AboutUs/womenIpadPro.jpg';
import MeetWomenIpad from '../../Assets/images/AboutUs/womenIpad.png';
import MeetMenIpad from '../../Assets/images/AboutUs/menIpad.png';
import MeetingOfficeIpad from '../../Assets/images/AboutUs/meetinOfficeIpad.jpg';
import MeetOfficeMenMobile from '../../Assets/images/AboutUs/menMob.jpg';
import MeetImgMobile from '../../Assets/images/AboutUs/womenMob.jpg';
import MeetWomenMob from '../../Assets/images/AboutUs/MeetingWomenMob.jpg';
import MeetMenMob from '../../Assets/images/AboutUs/mettinMenMob.jpg';
import MeetingOfficeMob from '../../Assets/images/AboutUs/meetingOfficeMob.jpg';
import { autoPlay } from 'react-swipeable-views-utils';
import SwipeableViews from 'react-swipeable-views';
import MobileStepper from '@material-ui/core/MobileStepper';
import Button from '@material-ui/core/Button';

import { Helmet } from 'react-helmet';
import { seoData } from '../../global/seoData';
import { globalVal } from '../../global/globalvalues';
import ButtonNew from '../../components/Button/Button';
//import MetaTags from 'react-meta-tags';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);
type initialProps = {
    history: any;
};
type initialState = { activeStep: number; autoPlay: boolean };

export class AboutUs extends Component<initialProps, initialState> {
    state: initialState = {
        activeStep: 0,
        autoPlay: true,
    };
    handleNext = () => {
        this.setState(prevState => ({
            activeStep: prevState.activeStep + 1,
        }));
    };

    handleBack = () => {
        this.setState(prevState => ({
            activeStep: prevState.activeStep - 1,
        }));
    };

    handleStepChange = (activeStep: number) => {
        this.setState({ activeStep });
    };
    handleAutoPlay = (val: boolean) => {
        this.setState({
            autoPlay: val,
        });
    };
    render() {
        const commitedToAwesomeText = aboutUsPage.commitedToAwesomeText;
        const maxSteps = commitedToAwesomeText.length;
        const { activeStep, autoPlay } = this.state;
        return (
            <div className="aboutUsPageMain">
                <Helmet>
                    <title>{seoData.aboutUs.title}</title>
                    <meta property="og:site_name" name="site_name" content={globalVal && globalVal.long_name} />
                    <meta property="og:title"  name="title" content={seoData.aboutUs.title} />
                    <meta property="og:description" name="description" content={seoData.aboutUs.description} />
                    <meta name="keywords" content={seoData.aboutUs.keywords} />
                </Helmet>
                <Header history={this.props.history} />
                <div className="mediaQueriesAboutUs">
                    <div className="aboutUsContent">
                        <h1 className="aboutUsTopHeading">{aboutUsPage && aboutUsPage.topHeading}</h1>
                        <div className="aboutUsMissionTitle">{aboutUsPage && aboutUsPage.missionTitle}</div>
                        <div className="imageWrapperDiv">
                            <div className="imgContainer">
                                <div className="missionImg1">
                                    <img src={MissionImg1} alt="" />
                                    <div className="imgText">
                                        {aboutUsPage && aboutUsPage.mission1 && aboutUsPage.mission1.text}
                                    </div>
                                </div>
                                <div className="imgSubText">
                                    {aboutUsPage && aboutUsPage.mission1 && aboutUsPage.mission1.subText}
                                </div>
                            </div>

                            <div className="imgContainer">
                                <div className="missionImg2">
                                    <img src={MissionImg2} alt="" />
                                    <div className="imgText">
                                        {aboutUsPage && aboutUsPage.mission2 && aboutUsPage.mission2.text}
                                    </div>
                                </div>
                                <div className="imgSubText">
                                    {aboutUsPage && aboutUsPage.mission2 && aboutUsPage.mission2.subText}
                                </div>
                            </div>
                        </div>
                        <div className="newsRoomDiv">
                            <div className="newsImages">
                                <a
                                    id="newsroomBusinesswireUrl"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://www.businesswire.com/news/home/20191001005273/en/Reach-Mobile-Launches-Mobile-Service-Bridge-Digital"
                                >
                                    {' '}
                                    <img src={BusinessImg} alt="" />
                                </a>
                                <a
                                    id="newsroomLowellsunUrl"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://www.lowellsun.com/2019/11/07/reach-mobile/"
                                >
                                    {' '}
                                    <img src={SunImg} alt="" />
                                </a>
                                <a
                                    id="newsroomBloombergUrl"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://www.bloomberg.com/press-releases/2019-10-01/reach-mobile-launches-mobile-service-to-help-bridge-the-digital-divide"
                                >
                                    {' '}
                                    <img src={Bloomberg} alt="" />
                                </a>
                            </div>
                        </div>
                        <div className="newsRoomMobileDiv">
                            <div className="newsImagesMobile">
                                <a
                                    id="newsroomBusinesswireUrl"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://www.businesswire.com/news/home/20191001005273/en/Reach-Mobile-Launches-Mobile-Service-Bridge-Digital"
                                >
                                    {' '}
                                    <img src={BusinessMob} alt="" />
                                </a>
                                <a
                                    id="newsroomLowellsunUrl"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://www.lowellsun.com/2019/11/07/reach-mobile/"
                                >
                                    <img src={SunMob} alt="" />
                                </a>
                                <a
                                    id="newsroomBloombergUrl"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://www.bloomberg.com/press-releases/2019-10-01/reach-mobile-launches-mobile-service-to-help-bridge-the-digital-divide"
                                >
                                    <img src={BloombergMob} alt="" />
                                </a>
                            </div>
                        </div>

                        <div className="commitedAwesomeDiv">
                            <div className="commitedAwesomeTextWrap">
                                <div className="AboutUsTitle"> {aboutUsPage && aboutUsPage.commitedTitle}</div>
                                <div className="AboutLine"></div>

                                <div className="commitedAwesomeText">{aboutUsPage && aboutUsPage.commitedText}</div>
                                <ButtonNew
                                  primary={true}
                                  className="learn-more-btn"
                                    onClick={() =>
                                        window.open(
                                            'https://connect.reachmobile.com/the-reach-10/',
                                            '_blank',
                                        )
                                    }
                                >
                                   Learn More
                                </ButtonNew>
                            </div>
                            <div
                                className="commitedAwesomeSliders"
                                onMouseEnter={() => this.handleAutoPlay(false)}
                                onMouseLeave={() => this.handleAutoPlay(true)}
                            >
                                <AutoPlaySwipeableViews
                                    index={activeStep}
                                    onChangeIndex={this.handleStepChange}
                                    interval={3000}
                                    autoplay={autoPlay}
                                    // enableMouseEvents
                                >
                                    {commitedToAwesomeText.map((step: any) => (
                                        <div key={step.label}>
                                            {/* {Math.abs(activeStep - index) <= 2 ? ( */}
                                            <div className="cardsDiv">
                                                <div className="row1Div">
                                                    <div className="individualDiv"></div>
                                                    <div className="individualDiv">
                                                        <div className="title">{step.box1.title}</div>
                                                        <div className="subtext">{step.box1.subtext}</div>
                                                    </div>
                                                    <div className="individualDiv">
                                                        <div className="title">{step.box2.title}</div>
                                                        <div className="subtext">{step.box2.subtext}</div>
                                                    </div>
                                                </div>
                                                <div className="row2Div">
                                                    <div className="individualDiv">
                                                        <div className="title">{step.box3.title}</div>
                                                        <div className="subtext">{step.box3.subtext}</div>
                                                    </div>
                                                    <div className="individualDiv">
                                                        <div className="title">{step.box4.title}</div>
                                                        <div className="subtext">{step.box4.subtext}</div>
                                                    </div>
                                                    <div className="individualDiv">
                                                        <div className="title">{step.box5.title}</div>
                                                        <div className="subtext">{step.box5.subtext}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* ) : null} */}
                                        </div>
                                    ))}
                                </AutoPlaySwipeableViews>
                                <MobileStepper
                                    steps={maxSteps}
                                    position="static"
                                    activeStep={activeStep}
                                    nextButton={
                                        <Button
                                            size="small"
                                            onClick={this.handleNext}
                                            disabled={activeStep === maxSteps - 1}
                                        >
                                            Next
                                        </Button>
                                    }
                                    backButton={
                                        <Button size="small" onClick={this.handleBack} disabled={activeStep === 0}>
                                            previous
                                        </Button>
                                    }
                                />
                            </div>
                        </div>

                        <div className="ceoLetterDiv">
                            <div className="ceoLetterTextWrap">
                                <div className="AboutUsTitle"> {aboutUsPage && aboutUsPage.letterTitle}</div>
                                <div className="AboutLine"></div>

                                <div
                                    className="ceoLetterText"
                                    dangerouslySetInnerHTML={{
                                        __html: aboutUsPage && aboutUsPage.ceoLetter,
                                    }}
                                ></div>
                            </div>
                            <div className="ceoImage">
                                <img src={CEOImg} alt="" />
                                <div
                                    className="ceoName"
                                    dangerouslySetInnerHTML={{
                                        __html: aboutUsPage && aboutUsPage.ceoName,
                                    }}
                                ></div>
                            </div>
                        </div>
                        <div className="meetOurTeam">
                            <div className="meetOurTeamText">
                                <div className="AboutUsTitle"> {aboutUsPage && aboutUsPage.meetTitle}</div>
                                <div className="AboutLine"></div>

                                <div className="meetText">{aboutUsPage && aboutUsPage.meetText}</div>
                            </div>
                            <div className="meetOurTeamGraphics">
                                <div className="meetPeople">
                                    <img alt="" className="img1" src={MeetOfficeMen} />
                                    <img alt="" className="img1Ipadpro" src={MeetOfficeMenIpadPro} />
                                    <img alt="" className="img1Mob" src={MeetOfficeMenMobile} />

                                    <img alt="" className="img2" src={MeetImg} />
                                    <img alt="" className="img2Ipadpro" src={MeetImgIpadPro} />
                                    <img alt="" className="img2Mob" src={MeetImgMobile} />
                                </div>
                                <div className="meetOffice">
                                    <div className="meetOfficePeople">
                                        <img alt="" src={MeetWomen} className="womenMain" />
                                        <img alt="" src={MeetWomenIpadPro} className="womenIpadPro" />
                                        <img alt="" src={MeetWomenIpad} className="womenIpad" />
                                        <img alt="" src={MeetWomenMob} className="womenMob" />

                                        <img alt="" src={MeetMen} className="menMain" />
                                        <img alt="" src={MeetMenIpadPro} className="menIpadPro" />
                                        <img alt="" src={MeetMenIpad} className="menIpad" />
                                        <img alt="" src={MeetMenMob} className="menMob" />
                                    </div>
                                    <img alt="" src={MeetOffice} className="meetOfficemain" />
                                    <img alt="" src={MeetofficeTab} className="meetOfficeTab" />
                                    <img alt="" src={MeetingOfficeIpad} className="meetOfficeIpad" />
                                    <img alt="" src={MeetingOfficeMob} className="meetOfficeMob" />
                                </div>
                            </div>
                        </div>

                        <div className="placardsDiv">
                            <div className="placardsWrap">
                                {aboutUsPage &&
                                    aboutUsPage.placards.length > 0 &&
                                    aboutUsPage.placards.map((item: any, index: number) => {
                                        return (
                                            <div key={index} className="placardsData">
                                                <div className="placardsImgDiv">
                                                    <img src={item.image} alt="" className="placardsImg" />
                                                </div>
                                                <div className="placardsText">{item.text}</div>
                                                <div
                                                    className="placardsSubtext"
                                                    dangerouslySetInnerHTML={{
                                                        __html: item.subText,
                                                    }}
                                                ></div>
                                            </div>
                                        );
                                    })}
                            </div>
                        </div>
                    </div>
                </div>

                <Footer isFixed={true} />
            </div>
        );
    }
}

export default AboutUs;
